import { render, staticRenderFns } from "./wx_informationBinding.vue?vue&type=template&id=1ea1cc6c&scoped=true"
import script from "./wx_informationBinding.vue?vue&type=script&lang=js"
export * from "./wx_informationBinding.vue?vue&type=script&lang=js"
import style0 from "./wx_informationBinding.vue?vue&type=style&index=0&id=1ea1cc6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea1cc6c",
  null
  
)

export default component.exports